import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';

import { email as userEmailSelector } from '@Containers/Header/HeaderComponentSelectors';

import { remoteAccessDialogReducerKey, typeOfRemoteAccessDialog } from './RemoteAccessDialogConstants';
import { step as stepSelector, departments as departmentsSelector } from './RemoteAccessDialogSelectors';
import {
  fetchDepartments as fetchDepartmentsAction,
  onDepartmentSelect as onDepartmentSelectAction,
  onActivationConfirm as onActivationConfirmAction,
} from './RemoteAccessDialogActions';
import remoteAccessDialogReducer from './RemoteAccessDialogReducer';
import RemoteAccessDialog from './RemoteAccessDialog';

const mapStateToProps = (state) => ({
  step: stepSelector(state),
  email: userEmailSelector(state),
  departments: departmentsSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchDepartments: (email) => dispatch(fetchDepartmentsAction(email)),
  onDepartmentSelect: (department, email) => dispatch(onDepartmentSelectAction(department, email)),
  onActivationConfirm: () => dispatch(onActivationConfirmAction(ownProps)),
  onClose: () => dispatch(closeDialog({ id: typeOfRemoteAccessDialog })),
});

export default compose(
  withReducer(remoteAccessDialogReducerKey, remoteAccessDialogReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(RemoteAccessDialog);
